import { createContext } from 'react';

import { Context } from '../../../types';
import { SupplierApplyBankTransferChargeOption } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<SupplierApplyBankTransferChargeOption>>(getContextDefaultValues(api));
